/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ProposalForClient,
    ProposalForClientFromJSON,
    ProposalForClientToJSON,
} from '../models';

export interface GetProposalsV1DffproposalsMyGetRequest {
    monitoredObjectIds?: Array<number>;
    proposalsPerVehicle?: number;
    subscribeUser?: string;
    subscribeDevice?: string;
    monitoredObjectId?: number;
}

/**
 * no description
 */
export class DffProposalsApi extends runtime.BaseAPI {

    /**
     * Get Proposals
     */
    async getProposalsV1DffproposalsMyGetRaw(requestParameters: GetProposalsV1DffproposalsMyGetRequest): Promise<runtime.ApiResponse<Array<ProposalForClient>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.monitoredObjectIds) {
            queryParameters['monitored_object_ids'] = requestParameters.monitoredObjectIds;
        }

        if (requestParameters.proposalsPerVehicle !== undefined) {
            queryParameters['proposals_per_vehicle'] = requestParameters.proposalsPerVehicle;
        }

        if (requestParameters.subscribeUser !== undefined) {
            queryParameters['subscribe_user'] = requestParameters.subscribeUser;
        }

        if (requestParameters.subscribeDevice !== undefined) {
            queryParameters['subscribe_device'] = requestParameters.subscribeDevice;
        }

        if (requestParameters.monitoredObjectId !== undefined) {
            queryParameters['monitored_object_id'] = requestParameters.monitoredObjectId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/dffproposals/my`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProposalForClientFromJSON));
    }

    /**
     * Get Proposals
     */
    async getProposalsV1DffproposalsMyGet(requestParameters: GetProposalsV1DffproposalsMyGetRequest): Promise<Array<ProposalForClient>> {
        const response = await this.getProposalsV1DffproposalsMyGetRaw(requestParameters);
        return await response.value();
    }

}
